// src/app/services/license.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from "../../../../environments/environment";
import {BehaviorSubject, Observable} from 'rxjs';
import {tap} from "rxjs/operators";
import {Router} from "@angular/router";

export interface LicenseStatus {
    status: 'valid' | 'expiring' | 'expired' | 'missing' | 'invalid' | 'disabled';
    client_name?: string;
    end_date?: string;
    days_remaining?: number;
    message?: string;
}

@Injectable({
    providedIn: 'root',
})
export class LicenseService {
    private baseUrl = environment.apiBaseUrl;

    private statusSubject = new BehaviorSubject<LicenseStatus | null>(null);

    status$ = this.statusSubject.asObservable(); // Observable exposé au composant
  constructor(private http: HttpClient, private router: Router) { }

    getLicenseStatus(): Observable<LicenseStatus> {
        return this.http.get<LicenseStatus>(`${this.baseUrl}/license/status`);
    }

    loadStatus() {
        // return this.http.get<LicenseStatus>(`${this.baseUrl}/license/status`).pipe(
        //     tap((status) => this.statusSubject.next(status)) // met à jour le BehaviorSubject
        // );
        this.http.get<LicenseStatus>(`${this.baseUrl}/license/status`).pipe(
            tap(status => {
                console.log(status)
                this.statusSubject.next(status)
                if (status.status == 'expired'){
                    this.router.navigate(['/error-page/license-expired']);
                }
            })
        ).subscribe({
            /*error: () => this.statusSubject.next({
                status: 'missing',
                message: 'Erreur lors de la vérification de la licence.'
				console.log('esrrr')
            })*/
			error: (err) => {
				console.log(err);
				this.statusSubject.next(err)
				
			}
        });
    }

    // Pour forcer le rafraîchissement depuis un autre composant
    refreshStatus(): void {
        this.getLicenseStatus().subscribe();
    }

    updateStatus(status: LicenseStatus): void {
        this.statusSubject.next(status);
    }

}
